import { requestApi } from '../util/network'

// 修改密码 传 old_password、password、password_confirm、type [ password、pay_password ]
export const change_password =
  (old_password, password, password_confirm, type) =>
    requestApi(
      '/member/change_password',
      'POST',
      {
        'old_password': old_password,
        'password': password,
        'password_confirm': password_confirm,
        'type': type,
      },
      'member'
    )
// 邮箱修改密码 传email、code、password、password_confirm
export const forgetEmail =
  (member_name, userName, captcha, password, confirmPassword, type = 'password') =>
    requestApi(
      '/connect/find_password_for_email',
      'POST',
      {
        'member_name': member_name,
        'email': userName,
        'code': captcha,
        'password': password,
        'password_confirm': confirmPassword,
        'type': type,
      }
    )

export const forget =
  (userName, captcha, password, confirmPassword) =>
    requestApi(
      '/Connect/find_password',
      'POST',
      {
        'phone': userName,
        'captcha': captcha,
        'password': password,
        'password_confirm': confirmPassword,
        'client': 'wap'
      }
    )
